<script>
  import logo from '@/assets/img/apps_logo-tall.png'
  import logo_h from '@/assets/img/apps_logo-horizontal.png'

  function baseTemplate(slot = '<slot />') {
    return '<div class="wizard" :class="{haslogo: logo}">\
        <div class="contents">\
          <figure class="logo" v-if="logo">\
            <img :src=logoimg :alt="$t(\'title\')" />\
          </figure>\
          ' + slot + '\
        </div>\
      </div>';
  }

  var baseProps = {
    logo: {
      type: [Boolean, String],
      default: 'tall',
    },
  };

  //Wizard with one slot

  var Wizard = {
    name: 'Wizard',
    template: baseTemplate(),
    props: baseProps,
    computed: {
      logoimg () {
        if (this.logo === 'vertical') {
          return logo;
        } else if (this.logo) {
          return logo_h;
        }
      },
    },
    mounted () {
      document.body.classList.add('modal-open');
    },
    destroyed () {
      document.body.classList.remove('modal-open');
    },
  }
  export default Wizard;

  //Wizard with router-view

  export function WithProps(props = []) {
    if (Array.isArray(props)) {
      var _obj = {};
      for (let prop of props) {
        _obj[prop] =  {
          type: null, //any
          required: true,
        }
      }
      props = _obj;
    }
    var propsArgs = Object.keys(props).map(p => ':' + p + '=' + p).join(' ');
    return Object.assign({}, Wizard, {
      props: Object.assign({}, baseProps, props),
      template: baseTemplate('<router-view ' + propsArgs + ' />'),
    });
  }

</script>

<style lang="scss">
  @media print {
    .wizard ~ * {
      display: none !important;
    }
    body.modal-open {
      display: contents;
      margin: 0 !important;
      padding: 0 !important;
      span.dialogsholder:not(:empty) + #main {
        display: none;
      }
      .wizard {
        position: static;
        background: none;
        padding: 0;
        .contents {
          position: static;
          border: none;
          box-shadow: none !important;
        }
      }
    }
  }
  @media screen {
    body.modal-open {
      overflow: hidden;
    }
  }
  
  div.wizard {
    position: fixed;
    padding-top: 4vh;
    display: block;
    content: '';
    background: rgba(black, .4);
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    overflow: auto;
    .contents {
      background: white;
      position: relative;
      width: $modal-width;
      max-width: 100vw;
      margin: 0 auto;
      padding: $modal-padding;
      @media (max-width: $xs-max) {
        padding: 20px !important;
      }
      text-align: center;
      border: solid #BBBABA 3px;
      p.introduction {
        margin: 0 0 20px;
      }
      .title:first-child {
        margin-top: 0;
      }
      .logo {
        margin-bottom: 5px;
        img {
          width: 183px;
          margin-bottom: 20px;
        }
      }
      .arrow {
        display: none;
        @media (min-width: $lg-min) {
          display: inline-block;
        }
        position: absolute;
        @include svg-bg(arrow, 'white');
        width: 49px;
        height: 98px;
        background-size: contain;
        top: 50%;
        transform: translateY(-50%);
        &.next, &.forward {
          right: -84px;
        }
        &[disabled] {
          display: none;
        }
        &.prev, &.previous, &.back {
          left: -84px;
          transform: translateY(-50%) rotate(180deg);
        }
      }
      .close {
        @extend %close-icon;
        @media print {
          display: none;
        }
      }
    }
    @media (min-height: 500px) {
      &.center .contents {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &.message .contents {
      width: 463px;
      padding: 65px 30px;
      .form-group {
        display: block;
        label, select {
          text-align: center;
        }
      }
    }
    &.sm .contents {
      width: $modal-width-sm;
    }
    &.md .contents {
      width: $modal-width-md;
    }
    &.xs .contents {
      width: $modal-width-sm;
    }
    &.left .contents .form-group {
      label, select {
        text-align: left;
      }
    }
    &.error .contents {
        border-color: $state-error !important;
    }

    &.lonely {
      background: rgba($body-bg, .4);
      >>> .contents {
        background: none;
        border: none;
        > figure.logo {
          margin-bottom: 26px;
          img {
            width: 400px;
            margin: 20px 0;
          }
          &, ~ * {
            background: white;
            width: 100%;
            @include panel-shadow;
          }
          + :last-child {
            padding: 50px 150px;
          }
        }
      }
    }
    &:not(.haslogo) .contents {
      padding: 28px 50px;
      .close {
        top: 0;
        right: 0;
        transform: scale(0.7);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/display/Wizard.vue